import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import thunkMiddleware from 'redux-thunk';
import userReducer from "@/redux/slices/userSlices";

const rootPersistConfig = {
    key: "root",
    storage: storage,
};

const rootReducer = combineReducers({
    user: userReducer,
});

export const store = configureStore({
    reducer: persistReducer(rootPersistConfig, rootReducer),
    middleware: [thunkMiddleware],
    devTools: process.env.REACT_APP_NODE_ENV !== "production",
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);